import { render, staticRenderFns } from "./ConceptProductTable.vue?vue&type=template&id=199e6d5a&"
import script from "./ConceptProductTable.vue?vue&type=script&lang=ts&"
export * from "./ConceptProductTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports